import React, {Component} from 'react';
import Table from "../General/table";

class ClientEnabledOffers extends Component {

    componentDidMount(){
        this.props.getEnabledOffers({
            filter: {
                where: {
                    and: [
                        {personId: this.props.match.params.id},
                        {or: [{expired: false}, {expired: null}]},
                        {or: [{redeemed: false}, {redeemed: null}]}
                        ]
                },
                include: 'offer'
            }
        })
    }

    render(){
        return (
            <Table
                handleRowSelect={this.props.handleOfferRowSelect}
                label="Enabled Offers"
                rows={this.props.offersTableRows}
                columns={this.props.offersTableColumns}

                fixedHeader={true}
                selectable={false}
                multiSelectable={false}

                displaySelectAll={false}
                showCheckboxes={false}
                showRowHover={true}
                clickableRows={true}
                page={this.props.offersListPage}
                rowsPerPage={this.props.offersListRowsPerPage}
                handleRowsPerPage={this.props.handleOfferListRowsPerPage}
                handlePageChange={this.props.handleOfferListPageChange}
                totalRows={this.props.offersTotalRows}

            />
        )
    }
}

export default ClientEnabledOffers;


// WEBPACK FOOTER //
// ./src/components/Clients/clientEnalbedOffers.js